import HttpRequest from "@/api/axios";
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default{
    jsapiConfig (data) {
        return axios.request({
            url: "api/mpjsconfig",
            method: "post",
            data
        });
    },

}
